import { ColumnDef, RowSelectionState } from "@tanstack/react-table";
import { RowQuery } from "./table";

export function isRemote<RowType>(data: RowType[] | RowQuery<RowType>) {
  return typeof data === "function";
}

export function parseToRowSelection(rows: string[]) {
  const selection: RowSelectionState = {};
  for (const row of rows) selection[row] = true;
  return selection;
}

export function parseFromRowSelection(selection: RowSelectionState) {
  const rows: string[] = [];
  for (const [key, value] of Object.entries(selection)) {
    if (value) rows.push(key);
  }
  return rows;
}

export function canSelectColumn<RowType>(
  column: ColumnDef<RowType>,
  enableColumnSelection: boolean | ((column: ColumnDef<RowType>) => boolean)
) {
  if (typeof enableColumnSelection === "function")
    return enableColumnSelection(column);

  return enableColumnSelection;
}

export function canMultiSelectColumn<RowType>(
  column: ColumnDef<RowType>,
  enableMultiColumnSelection:
    | boolean
    | ((column: ColumnDef<RowType>) => boolean)
) {
  if (typeof enableMultiColumnSelection === "function")
    return enableMultiColumnSelection(column);

  return enableMultiColumnSelection;
}
